angular
  .module("footerPostVendita.componets", [])
  .component("footerPostVendita", {
    templateUrl: "ng/components/footerPostVendita/footer.view.html",
    bindings: {
      nextStepVisible: "<",
      backStepVisible: "<",
      pauseVisible: "<",
      nextStepEnabled: "<",
      backStepEnabled: "<",
      pauseEnabled: "<",
      titleNextStep: "<",
      titleBackStep: "<",
      navigationBack: "&",
      navigationNext: "&",
      navigationPause: "&?",
      titleNext: "@",
      titleBack: "@",
      loaderBack: '<',
      loaderNext: '<',
      loaderSuspend: '<'
    },
    controllerAs: "footerPostVenditaCtrl",
    controller: function ($modalService) {
      var self = this;
      self.$modalService = $modalService;

      self.$onInit = function () {};

      self.$onChanges = function (changes) {
        if (changes.loaderBack) {
          self.navigator.loading.back = changes.loaderBack.currentValue;
        }
        if (changes.loaderNext) {
          self.navigator.loading.next = changes.loaderNext.currentValue;
        }
        if (changes.loaderSuspend) {
          self.navigator.loading.pause = changes.loaderSuspend.currentValue;
        }
      }

      self.navigator = {
        loading: {
          next: false,
          back: false,
          pause: false
        },
        somethingLoading: function () {
          var some = false;
          Object.keys(this.loading).forEach(function (value) {
            if (self.navigator.loading[value] == true) {
              some = true;
            }
          });
          return some;
        },
        nextStep: function () {
          this.loading.next = true;
          self.navigationNext();
          this.loading.next = false;
        },
        backStep: function () {

          this.loading.back = true;
          self.navigationBack();
          this.loading.back = false;
        },
      };

      self.nextStepIsEnabled = function () {
        return self.nextStepEnabled
      }
    }
  });